import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetPostingPlansApiResponse } from '../types';

export const getPostingPlans = async (): Promise<IGetPostingPlansApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetPostingPlansApiResponse>('/payment/user/plans', {
    headers,
  });

  return response.data;
};
